import type { ReactNode } from 'react';

interface SegOption<V extends string> {
  value: V;
  label: string;
  icon?: ReactNode;
}

interface SegProps<V extends string> {
  options: SegOption<V>[] | V[];
  value: V;
  onChange: (value: V) => void;
  size?: 'sm' | 'md';
}

export function Seg<V extends string>({ options, value, onChange, size = 'md' }: SegProps<V>) {
  const h = size === 'sm' ? 30 : 36;
  return (
    <div
      style={{
        display: 'inline-flex',
        background: 'rgba(15,30,61,.05)',
        padding: 3,
        borderRadius: h / 2,
        gap: 2,
      }}
    >
      {options.map((o) => {
        const v = typeof o === 'string' ? (o as V) : o.value;
        const label = typeof o === 'string' ? o : o.label;
        const icon = typeof o === 'string' ? null : o.icon;
        const active = v === value;
        return (
          <button
            key={v}
            onClick={() => onChange(v)}
            style={{
              height: h - 6,
              padding: '0 12px',
              border: 'none',
              cursor: 'pointer',
              background: active ? '#fff' : 'transparent',
              color: active ? '#0f1e3d' : 'rgba(15,30,61,.65)',
              borderRadius: (h - 6) / 2,
              fontSize: 13,
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              boxShadow: active ? '0 1px 2px rgba(15,30,61,.1)' : 'none',
              transition: 'all .15s',
              whiteSpace: 'nowrap',
            }}
          >
            {icon}
            {label && label}
          </button>
        );
      })}
    </div>
  );
}
